import { notification } from 'antd';

import {
  ccadminLogin,
  ccadminLogout,
  confirmResetPassword,
  login,
  logout,
  sendResetEmail,
} from '../services/api';
import { setAuthority } from '../utils/authority';

// login user
export const LOGIN = 'sckrg/auth/LOGIN';
export const loginUser = (values) => async (dispatch) => {
  try {
    const user = await login(values);
    // сессия ccadmin нужна модулям на /ccadmin/api (индикаторы, дороги и т.д.);
    // её ошибка не должна блокировать основной вход
    try {
      await ccadminLogin(values);
    } catch (ccadminError) {
      // eslint-disable-next-line no-console
      console.warn(ccadminError);
    }
    setAuthority('AUTHED');
    window.localStorage.setItem('user_params', JSON.stringify(user));
    dispatch({ type: LOGIN, payload: user });
  } catch (e) {
    const { status, code, message: backendMessage } = e || {};

    if (code === 'UNAUTHORIZED') {
      notification.error({
        message: 'Ошибка авторизации',
        description: 'Неверное имя пользователя или пароль',
      });
    } else if (code === 'USER_LOCKED') {
      notification.error({
        message: 'Учётная запись заблокирована',
        description:
          backendMessage ||
          'Учётная запись временно заблокирована. Пожалуйста, обратитесь к администратору.',
      });
    } else if (status === 401) {
      notification.error({
        message: 'Ошибка авторизации',
        description: backendMessage || 'Неавторизованный доступ.',
      });
    } else {
      notification.error({
        message: 'Ошибка сервиса авторизации',
        description: backendMessage || 'Не удалось выполнить вход. Попробуйте позже.',
      });
    }
  }
};

// logout user
export const LOGOUT = 'sckrg/auth/LOGOUT';
export const logoutUser = () => async (dispatch) => {
  await Promise.allSettled([logout(), ccadminLogout()]);
  setAuthority('GUEST');
  dispatch({ type: LOGOUT });
  window.localStorage.removeItem('user_params');
};
export const SEND_RESET_EMAIL = 'sckrg/auth/SEND_RESET_EMAIL';
export const requestPasswordReset = (email) => async (dispatch) => {
  try {
    await sendResetEmail({ email });
    dispatch({ type: SEND_RESET_EMAIL, payload: { email, ok: true } });
    return true;
  } catch (e) {
    console.error('Ошибка в requestPasswordReset:', e);
    return false;
  }
};

export const RESET_PASSWORD = 'sckrg/auth/RESET_PASSWORD';
export const performPasswordReset = (token, password) => async (dispatch) => {
  try {
    await confirmResetPassword({ token, password });
    dispatch({ type: RESET_PASSWORD, payload: { ok: true } });
    return true;
  } catch (e) {
    console.error('Ошибка в performPasswordReset:', e);
    return false;
  }
};
